import { debounce } from '../utils/global-functions';

// https://learnersbucket.com/examples/interview/capture-product-visible-on-viewport-when-user-stops-scrolling/
// Helper function to check if element is in viewport
const isInViewport = function (elem) {
  const bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight)
  );
};

// Function which will add class to declared module
const getModules = function () {
  const modules = document.querySelectorAll('.tickertape');
  modules.forEach((module) => {
    isInViewport(module)
      ? module.classList.add('animate')
      : module.classList.remove('animate');
  });
};

// Assign the event listener
window.addEventListener('scroll', debounce(getModules, 100), false);
